import styled from 'styled-components'
// TODO change library
import { Modal } from 'reactstrap'
import { device, colors } from 'Styled/variables'

export const SimilarArtistContainer = styled.div`
  position: relative;
`

export const WrapperRelativeArtists = styled.div`
  position: absolute;
  top: 199px;
  left: 25px;
  right: 25px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
`

export const GenresUnchecked = styled.span`
  width: 10px;
  height: 10px;
  padding: 9.5px 1px;
  padding-right: 1px;
  cursor: pointer;
`

export const StyledDiv = styled.span`
  margin-bottom: 24px;
`

export const StyledModalSubHeader = styled.div`
  margin-bottom: 8px;
`

export const ChooseGenres = styled.div`
  margin-top: 65px;
  text-align: left;
`
export const WrapperForCloseBtn = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`

export const ModalSubHeaderContainer = styled.div`
  margin-bottom: 16px;
  @media ${device.mobileMin} {
    margin-bottom: 0px;
  }
`
export const SmallButton = styled.button`
  width: 40px;
  height: 40px;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  img {
    height: 10px;
  }
`
export const MobileModal = styled(Modal)`
  margin: 0;
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
  }
  .modal.modal__mobile {
    display: block;
  }
  .modal-dialog .modal__mobile {
    margin: 0 !important;
  }
  .modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto;
  }
  .modal__mobile-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }
  .modal__mobile-close {
    background-color: transparent;
    padding-right: 10px;
    color: ${colors.greyTextWhiteBg};
    opacity: 0.5;
  }
  .modal__mobile .modal__mobile-dialog {
    width: 100%;
    max-width: 100%;
    height: 100%;
    margin: 0px auto;
    margin-bottom: 1000px;
  }
  .modal-content {
    border-radius: 0px;
    height: 100%;
    margin-bottom: 500px;
    position: fixed;
    text-align: left;
    background-color: ${colors.white};
  }
  .modal__mobile .modal__mobile-dialog .modal-content {
    border-radius: 0px;
    height: 100%;
    margin-bottom: 500px;
    position: fixed;
  }
`
export const FormGroupFieldGenres = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 24px;
`

export const FormGroupFieldGenresModal = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 15px;
  @media (min-width: 576px) {
    margin-top: 68px;
  }
`

export const FormGroupArtist = styled.div`
  padding: 5px 21px 28px 25px;
  margin-top: -56px;
  margin-bottom: 24px;
`
export const FormGroupArtistFlex = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: auto;
`

export const Arrow = styled.button`
  position: absolute;
  margin-right: 8px;
  left: 18px;
  top: 16px;
  background-color: transparent;
  cursor: pointer;
  z-index: 2000;
  height: 25px;
  width: 25px;
`
export const SearchFormBtnBlock = styled.div`
  margin: 0 auto;
`
export const ListWrapper = styled.div`
  margin-top: 50px;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  height: 72px;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.25));
`
